import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../../shared/shared.module";
import { DynamicPaymentComponentCouponFormComponent } from "./dynamic-payment-component-coupon-form/dynamic-payment-component-coupon-form.component";
import { DynamicPaymentComponentLineItemComponent } from "./dynamic-payment-component-line-item/dynamic-payment-component-line-item.component";

@NgModule({
    declarations: [  
    ],
    imports: [
        SharedModule,
        ReactiveFormsModule,
        DynamicPaymentComponentCouponFormComponent,
        DynamicPaymentComponentLineItemComponent
    ],
    exports: [
        DynamicPaymentComponentCouponFormComponent,
        DynamicPaymentComponentLineItemComponent
    ]
})
export class CartModule{
    
}